module.exports = __webpack_public_path__ + "img/ExternalLink.9ba30387.svg";